var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: { width: "18", height: "10", xmlns: "http://www.w3.org/2000/svg" }
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", { attrs: { d: "M-7 21h32v-32H-7z" } }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            stroke: "#515166",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "M1 1l8 8 8-8"
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }